<template>
    <i class="l-ss-c-loading-spinner">
        <svg
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg">
            <circle
                cx="50"
                cy="50"
                r="45"/>
        </svg>
    </i>
</template>

<script>
    export default {
        name: 'loading-spinner',
    };
</script>

<style scoped>

</style>
